<template>
  <section>
     <span @click="showModal">
      <slot></slot>
    </span>    

    <b-modal v-model="modalShow" size="lg" centered no-fade>
      <div slot="modal-header" class="w-100">{{ $t('TEMPLATES.INITIATE_DOCUMENT.TITLE') }}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('TEMPLATES.INITIATE_DOCUMENT.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">

          <div class="form-group row">

            <label class="col-form-label">{{ $t('TEMPLATES.INITIATE_DOCUMENT.INPUT_NAME') }}</label>
            <b-input autofocus v-model.number="addName" required
              v-on:keyup.enter="initializeDocument" 
            ></b-input>
          </div>

      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn @click="hideModals">{{ $t('CLOSE')}}</b-btn>
        <b-button
          variant="primary"
          class="btn-fill"
          @click="initializeDocument"
        >{{ $t('TEMPLATES.INITIATE_DOCUMENT.ADD')}}</b-button>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      details: this.item,
      modalLoading: false,
      modalShow: false,
      addName: ''
    };
  },
  methods: {
    hideModals: function() {
      this.modalShow = false;
      this.modalLoading = false;
    },
    showModal: function() {
      this.modalShow = true;
    },
    initializeDocument: function() {
      let self = this;
      this.modalLoading = true;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/template/document/add", {
          name: this.addName,
          dclIdentity: this.details.documentVersion.dclIdentity
        })
        .then(function(result) {
          self.hideModals();
          self.$router.push({ name: 'Template.Document', params: { documentId: result.data.id } })
          self.$noty.info(self.$t("TEMPLATES.INITIATE_DOCUMENT.SUCCESS.CREATED"));            
        })
        .catch(function(error) {          
          self.$noty.error(self.$t(error.response.data));
          self.modalLoading = false;
        });
    }
  },
  mounted: function() {
  }
};
</script>
<style>
</style>